<template>
    <div class="focused-well-center-content">
        <tab-buttons
            v-if="!isFdaFriendly"
            class="tablet-screen"
            :tabs="smallScreenTabs"
            :active-tab="activeTab"
            @tabChanged="changeTab"
        />

        <div class="focused-well" :class="[activeTab, { 'fda-friendly': isFdaFriendly }]">
            <app-header />
            <!-- <focused-well-left-panel :class="activeTab" /> -->

            <div class="focused-well-video-container">
                <div class="video-left-controls">


                    <pn-duc-deg-fix-panel :well="focusedWell" />


                  <div>
                    <well-status-controls :well="focusedWell" class="focused my-2" />
                    <kid-score :well="focusedWell"/>
                  </div>


                    <div class="focal-zoom-brightness-container">
                        <focal-selector class="mt-3" orientation="horizontal" />

                        <zoom-selector class="mt-3" orientation="horizontal" />

                      <div class="video-left-control-container">
                        <div class="video-left-control-item left"><i class="fa fa-sun-o" /></div>

                        <div class="video-left-control-item right"><video-invert-toggle /></div>
                      </div>

                      <video-brightness-slider />
                    </div>
                </div>
<!--                <well-summary-mobile />-->

                <!-- key is needed to re-render videos on well change -->
                <standalone-well-video
                    v-if="focusedWell"
                    ref="wellVideo"
                    :key="focusedWell && focusedWell._id"
                    :well="focusedWell"
                    :is-demo="isBlastInfoDemo"
                    @currentEventChanged="currentEventChanged"
                />
            </div>

            <!-- <div class="focused-well-right-panel">
                <template v-if="!isFdaFriendly">
                    <tab-buttons
                        class="without-notes"
                        :tabs="bigScreenTabs"
                        :active-tab="activeTab"
                        @tabChanged="changeTab"
                    />
                    <tab-buttons
                        class="with-notes"
                        :tabs="smallScreenTabs"
                        :active-tab="activeTab"
                        @tabChanged="changeTab"
                    />

                    <morphokinetics-table
                        v-if="activeTab === 'annotated_events'"
                        :well="focusedWell"
                        :current-event="currentEvent"
                        @eventChosen="seekToEvent"
                    />

                    <blast-info
                        v-if="activeTab === 'blast_info'"
                        :well="focusedWell"
                        :is-demo="isBlastInfoDemo"
                    />
                </template>

                <notes-and-insights v-if="activeTab === 'notes_and_insights'" :well="focusedWell" />

                <video-settings-panel />
            </div> -->

            <prev-next-well-buttons :class="activeTab" />
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AppHeader from './Header'
import ZoomSelector from './common/ZoomSelector'
import FocalSelector from './common/FocalSelector'
import StandaloneWellVideo from './StandaloneWellVideo'
import TabButtons from './partials/TabButtons'
import BlastInfo from './BlastInfo'
import MorphokineticsTable from './MorphokineticsTable'
import FocusedWellLeftPanel from './FocusedWellLeftPanel'
import VideoSettingsPanel from '../components/tablet/VideoSettingsPanel'
import WellSummaryMobile from './partials/WellSummaryMobile'
import NotesAndInsights from './partials/NotesAndInsights'
import PrevNextWellButtons from '../components/PrevNextWellButtons'
import WellStatusControls from './common/WellStatusControls'
import PnDucDegFixPanel from './partials/PnDucDegFixPanel'
import VideoInvertToggle from "./common/VideoInvertToggle.vue";
import VideoBrightnessSlider from "./common/VideoBrightnessSlider.vue";
import KidScore from "./score-metrics/KidScore.vue";


export default {
    name: 'FocusedWellCenterContent',
    components: {
      KidScore,
      VideoBrightnessSlider,
        AppHeader,
        BlastInfo,
        MorphokineticsTable,
        FocusedWellLeftPanel,
        StandaloneWellVideo,
        ZoomSelector,
        FocalSelector,
        TabButtons,
        VideoSettingsPanel,
        WellSummaryMobile,
      VideoInvertToggle,
        PrevNextWellButtons,
        WellStatusControls,
        PnDucDegFixPanel
    },
    data: () => ({
        currentEvent: {},
        activeTab: 'annotated_events'
    }),
    computed: {
        ...mapState({
            focusedWell: state => state.timelapse.focusedWell,
            selectedTreatment: state => state.timelapse.selectedTreatment
        }),
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly'
        }),
        isBlastInfoDemo() {
            const { esId, slideId } = this.focusedWell
            const { slides } = this.selectedTreatment

            const slide = slides.find(_slide => _slide._id === slideId)

            return esId === '1' && slide.esId === 'S01733'
        },
        bigScreenTabs() {
            return ['annotated_events', 'blast_info']
        },
        smallScreenTabs() {
            const tabs = ['annotated_events', 'notes_and_insights']

            if (this.isBlastInfoDemo) {
                tabs.push('blast_info')
            }
            return tabs
        }
    },
    methods: {
        changeTab(tabName) {
            if (tabName === 'blast_info' && !this.isBlastInfoDemo) {
                return
            }
            this.activeTab = tabName
        },
        currentEventChanged(currentEvent) {
            this.currentEvent = currentEvent
        },
        seekToEvent(mkEvent) {
            this.$refs.wellVideo.skipVideoToMkEvent(mkEvent)
        },
        selectWell(isNext) {
            this.$log.actionEvent('prev_next_well')

            const desiredIndex = this.focusedWell.index + (isNext ? 1 : -1)
            const well = this.selectedTreatment.wellsByIndex[desiredIndex]

            if (well) {
                this.$mainController.selectWell(well)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.focused-well-center-content {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    color: $light-3;

    @media screen and #{$new-break4close} {
        background-color: $dark-3;
    }


.kid-score {
  margin-top: 2rem;
  width: 16rem;
  height: 3rem;
}
    .tab-buttons.tablet-screen {
        @media screen and #{$new-break2close}, #{$new-break5open} {
            display: none;
        }
    }

    .focused-well {
        position: relative;
        width: 100%;
        padding: 1rem;
        display: flex;
        overflow-y: auto;
        @include hide-scrollbar();

        .app-header {
            grid-area: header;
            z-index: 31;

            @media screen and #{$new-break3open} {
                display: none;
            }
        }

        .focused-well-video-container {
            grid-area: video;
            flex-grow: 0;
            display: flex;
            width: 100%;
            justify-content: center;
            @media screen and #{$new-break2close} {
                flex-direction: column;
                position: sticky;
                top: 0;
                z-index: 30;
            }
            @media screen and #{$new-break3open} {
                .well-summary-mobile {
                    display: none;
                }
            }
        }

        .prev-next-well-buttons {
            @media screen and #{$new-break2close} {
                &.annotated_events {
                    position: fixed;
                    bottom: 0;
                    width: 100%;
                    height: $well-video-controls-bottom-panel-height;
                    background: transparent linear-gradient(180deg, #191f2600 0%, #191f26 100%) 0 0
                        no-repeat padding-box;
                }
                &:not(.annotated_events) {
                    display: none;
                }
            }
            @media screen and #{$new-break3open} {
                display: none;
            }
        }

        @media screen and #{$new-break2close} {
            height: 100%;
            padding: 0;
            display: grid;
            grid-template-columns: 100%;
            grid-template-rows: repeat(3, min-content);
            grid-template-areas:
                'header'
                'video'
                'rightpanel';
        }

        @media screen and #{$new-break3}, #{$new-break4} {
            padding-bottom: 0;

            &.notes_and_insights {
                height: calc(100% - #{$tabs-height});
            }

            &:not(.notes_and_insights) {
                @media screen and #{$new-break3} {
                    // tabs + navigation-buttons + video-controls
                    height: calc(
                        100% - #{$tabs-height} - #{$well-video-controls-bottom-panel-height} * 2
                    );
                }
                @media screen and #{$new-break4} {
                    height: calc(
                        100% - #{$tabs-height} - #{$well-video-controls-bottom-panel-height}
                    );
                }
            }
        }

        @media screen and #{$new-break3} {
            padding: 0;
            overflow-y: auto;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: repeat(2, min-content);
            grid-template-areas:
                'leftpanel leftpanel'
                'video     rightpanel';
        }

        @media screen and #{$new-break4open} {
            display: flex;

            &.notes_and_insights {
                .focused-well-video-container,
                .focused-well-right-panel {
                    display: none;
                }

                .focused-well-left-panel {
                    height: 100%;
                    width: 100%;
                }
                .insights {
                    min-height: 20vh;
                }
            }
        }

        @media screen and #{$new-break5open} {
            height: 100%;
        }

        &.fda-friendly {
            display: grid;

            .focused-well-left-panel {
                grid-area: leftpanel;
            }
            .focused-well-video-container {
                grid-area: video;
            }

            @media screen and #{$new-break4open} {
                grid-template-columns: auto 1fr;
                grid-template-areas: 'video leftpanel';
            }
        }
    }



}
</style>

<style lang="scss">
.focused-well-center-content {
  .well-status-controls {
    width: 16rem;
    height: 2rem;
  }

  .video-left-control-container {
    display: flex;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }
  .video-left-control-item {
    background-color: #00bc8c;
    width: 8rem;
    height: 2rem;
    background-color: $dark-4;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .video-left-control-item.left{
    border-bottom-left-radius: $border-radius;
    border-top-left-radius: $border-radius;
    border-right: 0.1rem solid $dark-2;
  }

  .video-left-control-item.right{
    border-bottom-right-radius: $border-radius;
    border-top-right-radius: $border-radius;
  }
    .focused-well {
        .focused-well-left-panel {
            grid-area: leftpanel;

            @media screen and #{$new-break2close} {
                display: none;
            }
            @media screen and #{$new-break3}, #{$new-break4} {
                margin-right: 0;
            }
            @media screen and #{$new-break5open} {
                margin-right: 0.5rem;
                flex-basis: 0;
                flex-grow: 1;
            }
        }

        .focused-well-video-container {
            .video-left-controls {
              justify-content: space-between;
              padding-bottom: 1rem;
              align-items: center;
                display: flex;
                flex-direction: column;

                @media screen and #{$new-break4close} {
                    display: none;
                }
                @media screen and #{$new-break5open} {
                    display: flex;
                    flex-direction: column;
                    position: relative;
                    padding-left: 0.5rem;
                    background-color: $dark-3;
                    border-top-left-radius: $border-radius-lg;
                    border-bottom-left-radius: $border-radius-lg;

                    .zoom-selector,
                    .focal-selector {

                    }
                }
            }
        }

        // .focused-well-right-panel {
        //     grid-area: rightpanel;
        //     position: relative;
        //     flex-grow: 1;
        //     background-color: $dark-3;
        //     display: flex;
        //     flex-direction: column;

        //     .tab-buttons.without-notes {
        //         @media screen and #{$new-break4close} {
        //             display: none;
        //         }
        //     }
        //     .tab-buttons.with-notes {
        //         @media screen and #{$new-break3open} {
        //             display: none;
        //         }
        //     }

        //     .morphokinetics-table {
        //         flex-grow: 1;

        //         .colored-range {
        //             height: 2.8rem;
        //         }

        //         @media screen and #{$new-break2close} {
        //             // space for well buttons in mobile
        //             padding-bottom: $well-video-controls-bottom-panel-height;
        //         }
        //         @media screen and #{$new-break3open} {
        //             overflow: auto;
        //             @include hide-scrollbar();
        //         }
        //     }

        //     @media screen and #{$new-break4close} {
        //         margin-left: 0;
        //     }
        //     @media screen and #{$new-break5open} {
        //         margin-left: 0.5rem;
        //         flex-basis: 0;
        //     }
        // }

        .score-hazard-icon img {
            height: 1.4rem;
        }
        .hazard-icon {
            height: 1.6rem;
        }

        .video-settings-panel {
            @media screen and #{$new-break2close}, #{$new-break5open} {
                display: none;
            }
            @media screen and #{$new-break3}, #{$new-break4} {
                height: $video-width-height;
                position: absolute;
                top: 0;
                right: 0;
            }
        }

        @media screen and #{$new-break3} {
            .metrics-container {
                overflow-y: hidden !important;
                height: auto !important;
            }

            .video-brightness-slider,
            .video-invert-toggle {
                width: 100% !important;
                max-width: 100% !important;
                height: auto;
                padding: 0.7rem !important;
                justify-content: center;
            }

            // by selected tabs
            // &.annotated_events {
            //     .morphokinetics-table {
            //         height: 100%;
            //     }
            // }

            // &.blast_info {
            //     padding: 0 0 #{$well-video-controls-bottom-panel-height * 2} 0 !important;

            //     .morphokinetics-table {
            //         display: none;
            //     }
            // }

            // &.notes_and_insights {
            //     padding: 0 !important;

            //     .focused-well-video-container,
            //     .focused-well-right-panel,
            //     .prev-next-well-buttons {
            //         display: none;
            //     }

            //     .focused-well-left-panel {
            //         height: 100%;
            //     }
            //     .insights {
            //         min-height: 20vh;
            //     }
            // }
        }
    }
}
</style>
